module.exports = {
    lintOnSave: false,
    configureWebpack: {
        resolve: {
            fallback: {
                "assert": require.resolve("assert/")
            }
        }
    },
    devServer: {
        host: '0.0.0.0',
        port: 9091,
        allowedHosts: 'all',
        headers: {
            'Access-Control-Allow-Origin': '*'
        },
        //useLocalIp:false,
        proxy: {
            '/apidev': {
                target: 'http://localhost:5009/',
                pathRewrite: {'^/apidev' : ''}
            },
            '/resources': {
                target: 'http://localhost:5009/',
                pathRewrite: {'^/resources' : ''}
            }            
        }
    }
}
